import { Dashboard } from './types';

// NOTE: These constants define how the front-end detects whether a dashboard
// is BoldBI-capable. They reflect the backend's current convention of omitting
// these fields or setting them to the string "none" when a dashboard is not
// intended for BoldBI. If the backend changes the way it signals BoldBI
// availability (e.g. a dedicated `provider` flag), update this list + the
// sentinel value accordingly.
export const BOLDBI_REQUIRED_PARAMS = ['embedType', 'environment', 'expirationTime', 'siteIdentifier', 'serverUrl'] as const;

export const BOLDBI_INVALID_VALUE = 'none';

export const isValidBoldBiConfig = (dashboard?: Dashboard | null): boolean => {
    if (!dashboard) return false;
    return BOLDBI_REQUIRED_PARAMS.every((key) => {
        const value = dashboard[key];
        return value !== undefined && value !== null && value !== '' && value !== BOLDBI_INVALID_VALUE;
    });
};

/**
 * Returns the list of dashboards with selected attribute or empty array
 *
 * @param [dashboards] {Dashboard} Dashboard list
 * @param [selectedDashboard] {Dashboard} Dashboard selected
 */
export const getDashboardListWithSelected = (dashboards?: Dashboard[], selectedDashboard?: Dashboard) => {
    if (!dashboards) return [];
    return selectedDashboard
        ? dashboards
              .map((dashboard) =>
                  +dashboard.id === +selectedDashboard?.id ? { ...dashboard, selected: true } : { ...dashboard, selected: false }
              )
              .sort((a, b) => +b.selected - +a.selected)
        : dashboards
              .map((dashboard, index) => (index === 0 ? { ...dashboard, selected: true } : { ...dashboard, selected: false }))
              .sort((a, b) => +b.selected - +a.selected);
};
